/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ datasetCategoryId: ZodTypes.Id });
export const AdminDatasetCategoryPatch = {
  id: 'admin-dataset-category.patch',
  tag: 'Admin',
  summary: 'Admin Update Dataset Category',
  description: 'Update dataset categories',
  method: 'patch',
  flags: { isAuthorized: true, isSuperuser: true },
  route: (params: z.infer<typeof Params>) => `/administration/dataset-category/${params.datasetCategoryId}`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            identifier: z.string(),
            thumbnail: z.string(),
            i18n: z.array(
              z.strictObject({
                title: z.string(),
                language: ZodTypes.Language,
              }),
            ),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
